import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_INSTITUTIONITEMTEMPLATE_LOAD,
    ACTION_INSTITUTIONITEMTEMPLATE_LOAD_BY_ID,
    ACTION_INSTITUTIONITEMTEMPLATE_LOAD_FAILURE,
    ACTION_INSTITUTIONITEMTEMPLATE_LOAD_SUCCESS,

    ACTION_INSTITUTIONITEMTEMPLATE_SAVE,
    ACTION_INSTITUTIONITEMTEMPLATE_SAVE_SUCCESS,
    ACTION_INSTITUTIONITEMTEMPLATE_SAVE_FAILURE,

    ACTION_INSTITUTIONITEMTEMPLATE_CREATE,
    ACTION_INSTITUTIONITEMTEMPLATE_CREATE_SUCCESS,
    ACTION_INSTITUTIONITEMTEMPLATE_CREATE_FAILURE,

    ACTION_INSTITUTIONITEMTEMPLATE_VALIDATE,
    ACTION_INSTITUTIONITEMTEMPLATE_VALIDATE_SUCCESS,
    ACTION_INSTITUTIONITEMTEMPLATE_VALIDATE_FAILURE,

    ACTION_INSTITUTIONITEMTEMPLATE_CLEAR,
    ACTION_INSTITUTIONITEMTEMPLATES_FILTER,

    InstitutionItemTemplateAction
} from '../actions/institutionItemTemplate';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface IInstitutionItemTemplateState {
    formData: Dtos.InstitutionItemTemplate | Dtos.InstitutionItemTemplate[],
    formDataInstitutioned: Dtos.InstitutionItemTemplateCategory[];
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    validateState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.InstitutionItemTemplate[];
    formFilteredDataGrouped: Dtos.InstitutionItemTemplateCategory[];
}

const initialState: IInstitutionItemTemplateState = {
    formData: undefined,
    formDataInstitutioned: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    formFilteredDataGrouped: undefined,
};


function loading(state: IInstitutionItemTemplateState, _isLoading: boolean): IInstitutionItemTemplateState {
    const newState: IInstitutionItemTemplateState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(
    state: IInstitutionItemTemplateState,
    formData: Dtos.InstitutionItemTemplate | Dtos.InstitutionItemTemplate[],
    formDataInstitutioned: Dtos.InstitutionItemTemplateCategory[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): IInstitutionItemTemplateState {
    const newState: IInstitutionItemTemplateState = update(state, {
        formData: {
            $set: formData
        },
        formDataInstitutioned: {
            $set: formDataInstitutioned
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function filter(state: IInstitutionItemTemplateState, formFilter: IFormFilter): IInstitutionItemTemplateState {

    const formData: Dtos.InstitutionItemTemplate[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formFilteredData = formData ? formData.filter(p => (p.active == true || formFilter.showInActive) &&
        (formFilter.search == "" || p.name.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;

    let formFilteredDataGrouped = [];
    if (state.formDataInstitutioned) {
        for (var i = 0; i < state.formDataInstitutioned.length; i++) {
            const filteredInstitutionItemTemplateCategoryItems =
                state.formDataInstitutioned[i].institutionItemTemplates.filter(p => (p.active == true || formFilter.showInActive) &&
                    (formFilter.search == "" ||
                        (p.name != undefined && p.name.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1) ||
                        (p.description != undefined && p.description.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)
                    ));
            if (filteredInstitutionItemTemplateCategoryItems.length > 0) {
                formFilteredDataGrouped.push({
                    ...state.formDataInstitutioned[i],
                    institutionItemTemplates: filteredInstitutionItemTemplateCategoryItems
                });
            }
        }
    }

    const newState: IInstitutionItemTemplateState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        formFilteredDataGrouped: {
            $set: formFilteredDataGrouped
        }
    });

    return newState;
}

function loadFailure(state: IInstitutionItemTemplateState, responseStatus: Dtos.ResponseStatus): IInstitutionItemTemplateState {
    const newState: IInstitutionItemTemplateState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: IInstitutionItemTemplateState, propertiesToClear?: string[]): IInstitutionItemTemplateState {

    if (!propertiesToClear) {
        const newState: IInstitutionItemTemplateState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: IInstitutionItemTemplateState, _isSaving: boolean): IInstitutionItemTemplateState {
    const newState: IInstitutionItemTemplateState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: IInstitutionItemTemplateState,
    formData: Dtos.InstitutionItemTemplate | Dtos.InstitutionItemTemplate[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): IInstitutionItemTemplateState {
    const newState: IInstitutionItemTemplateState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: IInstitutionItemTemplateState, responseStatus: Dtos.ResponseStatus): IInstitutionItemTemplateState {
    const newState: IInstitutionItemTemplateState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: IInstitutionItemTemplateState, _isCreating: boolean): IInstitutionItemTemplateState {
    const newState: IInstitutionItemTemplateState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: IInstitutionItemTemplateState,
    formData: Dtos.InstitutionItemTemplate,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): IInstitutionItemTemplateState {
    const newState: IInstitutionItemTemplateState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: IInstitutionItemTemplateState, responseStatus: Dtos.ResponseStatus): IInstitutionItemTemplateState {
    const newState: IInstitutionItemTemplateState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function validating(state: IInstitutionItemTemplateState, _isValidating: boolean): IInstitutionItemTemplateState {
    const newState: IInstitutionItemTemplateState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: IInstitutionItemTemplateState,
    formData: Dtos.InstitutionItemTemplate,
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): IInstitutionItemTemplateState {
    const newState: IInstitutionItemTemplateState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: IInstitutionItemTemplateState, responseStatus: Dtos.ResponseStatus): IInstitutionItemTemplateState {
    const newState: IInstitutionItemTemplateState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

const InstitutionItemTemplateReducer: Reducer<IInstitutionItemTemplateState> = (state: IInstitutionItemTemplateState = initialState, action: InstitutionItemTemplateAction) => {
    switch (action.type) {
        case ACTION_INSTITUTIONITEMTEMPLATE_LOAD:
        case ACTION_INSTITUTIONITEMTEMPLATE_LOAD_BY_ID:
            return loading(state, true);
        case ACTION_INSTITUTIONITEMTEMPLATE_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formDataInstitutioned, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_INSTITUTIONITEMTEMPLATE_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_INSTITUTIONITEMTEMPLATE_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_INSTITUTIONITEMTEMPLATE_SAVE:
            return saving(state, true);
        case ACTION_INSTITUTIONITEMTEMPLATE_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_INSTITUTIONITEMTEMPLATE_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_INSTITUTIONITEMTEMPLATE_CREATE:
            return creating(state, true);
        case ACTION_INSTITUTIONITEMTEMPLATE_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_INSTITUTIONITEMTEMPLATE_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_INSTITUTIONITEMTEMPLATE_VALIDATE:
            return validating(state, true);
        case ACTION_INSTITUTIONITEMTEMPLATE_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_INSTITUTIONITEMTEMPLATE_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
        case ACTION_INSTITUTIONITEMTEMPLATES_FILTER:
            return filter(state, action.formFilter);
    }

    return state;
}

export default InstitutionItemTemplateReducer;